import { getProvider, setStateFromPayload } from "../navigoSlice";
import { modeRequiresLocation } from "./locationModes";

// Provider-search request body used by the default (non-geolocation) path.
function buildProviderBody({ patientId, planId, service, modeName }) {
  return {
    cityMatch: [],
    landmarkMatch: [],
    languageMatch: [],
    pageNum: 0,
    pageSize: 0,
    patientId,
    planId,
    serviceId: service?.serviceId,
    serviceMode: modeName,
    stateMatch: [],
  };
}

// Routes a (service, mode) pair into the correct next screen. For health
// checkups (serviceTypeId === 2): "Home sample" -> /bookingFor and
// location-based modes (e.g. "Centre visit") -> /select-location; everything
// else fetches providers and goes to /providerCard.
//
// NOTE: downstream screens read service.serviceModeDetails[0], so the caller
// must pass a service whose FIRST mode is the chosen one.
export function routeForServiceMode({
  service,
  modeName,
  planId,
  pageType,
  patientId,
  dispatch,
  history,
}) {
  const isHealthCheckup = service?.serviceTypeId === 2;

  // Seed the booking summary (shown in the bottom floater) with the committed
  // service + mode, and clear any stale member/address from a prior booking.
  dispatch(
    setStateFromPayload({
      currentServices: service,
      selectedBookingMode: modeName,
      selectedBookingProvider: null,
      familyMemberSelectedData: {},
      addressSelected: null,
    }),
  );

  if (pageType === 7) {
    // CMP / avail care program: skip provider selection and go straight to
    // the booking-for (self/family) screen.
    dispatch(
      setStateFromPayload({
        currentSelectedService: service,
        currentSelectedPlan: planId,
        isCmpBooking: true,
      }),
    );
    history.push("/bookingFor");
    return;
  }

  if (isHealthCheckup && modeName === "Home sample") {
    dispatch(
      setStateFromPayload({
        currentSelectedService: service,
        currentSelectedPlan: planId,
        isCmpBooking: false,
      }),
    );
    history.push("/bookingFor");
    return;
  }

  if (isHealthCheckup && modeRequiresLocation(modeName)) {
    history.push({
      pathname: "/select-location",
      state: { service, pageType, planId },
    });
    return;
  }

  dispatch(
    getProvider(buildProviderBody({ patientId, planId, service, modeName })),
  );
  history.push({
    pathname: "/providerCard",
    state: { service, pageType },
  });
}
